/**
 * Debug logging utility
 * 
 * Wraps console methods to conditionally log based on DEBUG_MODE flag.
 * console.error is always enabled for production error tracking.
 */

import { DEBUG_MODE } from '../config';

/**
 * Debug logger that only logs when DEBUG_MODE is enabled
 */
export const debug = {
  /**
   * Logs debug information (console.log equivalent)
   * Only logs when DEBUG_MODE is true
   */
  log: (...args: any[]): void => {
    if (DEBUG_MODE) {
      console.log(...args);
    }
  },

  /**
   * Logs debug information (console.debug equivalent)
   * Only logs when DEBUG_MODE is true
   */
  debug: (...args: any[]): void => {
    if (DEBUG_MODE) {
      console.debug(...args);
    }
  },

  /**
   * Logs informational messages (console.info equivalent)
   * Only logs when DEBUG_MODE is true
   */
  info: (...args: any[]): void => {
    if (DEBUG_MODE) {
      console.info(...args);
    }
  },

  /**
   * Logs warning messages (console.warn equivalent)
   * Only logs when DEBUG_MODE is true
   */
  warn: (...args: any[]): void => {
    if (DEBUG_MODE) {
      console.warn(...args);
    }
  },

  /**
   * Logs error messages
   * Always enabled for production error tracking
   */
  error: (...args: any[]): void => {
    console.error(...args);
  },
};
